import api from '../config/api';

const fragranceNoteService = {
  async getAll() {
    const response = await api.get('/api/fragrance-notes');
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/api/fragrance-notes/${id}`);
    return response.data;
  },

  async create(noteData) {
    const response = await api.post('/api/fragrance-notes', noteData);
    return response.data;
  },

  async update(id, noteData) {
    const response = await api.put(`/api/fragrance-notes/${id}`, noteData);
    return response.data;
  },

  async delete(id) {
    const response = await api.delete(`/api/fragrance-notes/${id}`);
    return response.data;
  },
};

export default fragranceNoteService;
